import React from "react";
import {Box} from "@cloudscape-design/components";

export const ValueWithLabel = ({ label, children } : {label : string, children: any}) => (
    <div>
      <Box variant="awsui-key-label">{label}</Box>
      <div data-testid={label.toLowerCase().replaceAll(" ", "-")}>{children}</div>
    </div>
  );